import React, { useMemo, useState } from 'react';
import { Container, Row } from 'reactstrap';
import { ClipLoader } from '../../components/ClipLoader';
import { useDispatch, useSelector } from 'react-redux';
import { DispatchType } from '../../../state/configureStore';
import { deleteUsersThunk, fetchUsersThunk } from '../../../state/users/reducer';
import { ApplicationState } from '../../../state/ApplicationState';
import { UsersTable } from './components/UsersTable';
import { UsersToolbar } from './components/UsersToolbar';
import { TachoConfirmationModal } from '../../components/TachoConfirmationModal';
import { AddUserModal } from '../../modals/users/AddUserModal';
import { searchInObject } from '../../../core/helpers/search';
import { UsersModel } from '../../../core/domainModels/users/UsersModel';
import { UpdateUserModal } from '../../modals/users/UpdateUserModal';

export const UsersPage = () => {
    const dispatch = useDispatch<DispatchType>();
    const users = useSelector((state: ApplicationState) => state.users.users);
    const fetchUsersPending = useSelector((state: ApplicationState) => state.users.fetchUsersPending);
    const deleteUsersPending = useSelector((state: ApplicationState) => state.users.deleteUsersPending);
    const deleteUsersError = useSelector((state: ApplicationState) => state.users.deleteUsersError);
    const [isConfirmRemoveModalOpen, setIsConfirmRemoveModalOpen] = useState(false);
    const [isOpenAddUserModal, setIsOpenAddUserModal] = useState(false);
    const [isOpenUpdateUserModal, setIsOpenUpdateUserModal] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState<Array<UsersModel>>([]);
    const [searchQuery, setSearchQuery] = useState('');
    const usersToShow = useMemo(() => {
        return searchQuery ? users.filter((users: UsersModel) => searchInObject(users, searchQuery)) : users;
    }, [users, searchQuery]);
    return (
        <Container fluid className="flexColumnFullHeightContainer">
            <UsersToolbar
                selectedUsers={selectedUsers}
                openAddUserModal={() => setIsOpenAddUserModal(!isOpenAddUserModal)}
                openUpdateUserModal={() => setIsOpenUpdateUserModal(!isOpenUpdateUserModal)}
                openConfirmRemoveModal={() => setIsConfirmRemoveModalOpen(!isConfirmRemoveModalOpen)}
                onRefresh={() => dispatch(fetchUsersThunk())}
                onSearchQueryChanged={setSearchQuery}
            />
            <Row className="ag-theme-balham tabTable flexGrowScrollableChild g-0">
                {fetchUsersPending ? (
                    <ClipLoader />
                ) : (
                    <UsersTable
                        onUserDoubleClicked={() => setIsOpenUpdateUserModal(!isOpenUpdateUserModal)}
                        onSelectionChanged={setSelectedUsers}
                        users={usersToShow}
                    />
                )}
            </Row>
            <TachoConfirmationModal
                isOpen={isConfirmRemoveModalOpen}
                onSubmit={() => dispatch(deleteUsersThunk(selectedUsers[0].email))}
                onToggle={() => setIsConfirmRemoveModalOpen(!isConfirmRemoveModalOpen)}
                message={'usersRemoveConfirmationMessage'}
                pending={deleteUsersPending}
                errorToTranslate={deleteUsersError}
                title={'usersDeleteUser'}
            />
            <AddUserModal isOpen={isOpenAddUserModal} onToggle={() => setIsOpenAddUserModal(!isOpenAddUserModal)} />
            <UpdateUserModal
                user={selectedUsers[0]}
                isOpen={isOpenUpdateUserModal}
                onToggle={() => setIsOpenUpdateUserModal(!isOpenUpdateUserModal)}
            />
        </Container>
    );
};
